<template>
  <div class="no-results-found">
    <h3 class="heading -medium">
      {{ title }}
    </h3>
    <p v-if="!showSalesCta">Try adjusting search filters for more results.</p>
    <p v-else>Get access to more options!</p>
    <div>
      <a v-if="!showSalesCta" class="btn -main -dark -no-case" @click="emit('clear-all')">{{
        buttonLabel
      }}</a>
      <a v-else class="btn -main -dark -no-case" :href="salesPageUrl">Shop More Options</a>
    </div>
  </div>
</template>

<script setup lang="ts">
/** PROPS **/
withDefaults(
  defineProps<{
    title?: string
    buttonLabel?: string
    showSalesCta?: boolean
    salesPageUrl?: string
  }>(),
  {
    title: 'No Results Found',
    buttonLabel: 'View All',
    showSalesCta: false,
    salesPageUrl: '',
  },
)

/** EMITS **/
const emit = defineEmits(['clear-all'])

/** METHODS **/
</script>
